<div class="category">
  <div class="font-bold mb-4">{{ "CATEGORY" | translate }}</div>
  <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input mb-2.5">
    <input
      nz-input
      type="text"
      [(ngModel)]="searchText"
      [placeholder]="'SEARCH_CATEGORY' | translate"
    />
    <ng-template #suffixTemplateInfo>
      <i class="search"></i>
    </ng-template>
  </nz-input-group>
  <nz-empty *ngIf="!filteredMenuData.length"></nz-empty>
  <nz-tree
  *ngIf="filteredMenuData.length"
  nzBlockNode
  nzShowIcon 
  [nzData]="filteredMenuData"
  [nzSearchValue]="searchText"
  [nzSelectedKeys]="nodeSelectedKeys"
  (nzClick)="handleTreeEvent($event)"
  [nzTreeTemplate]="nzTreeTemplate"
  [nzExpandedIcon]="customExpandIcon"
  [nzHideUnMatched]="true"
></nz-tree>
  <ng-template #customExpandIcon let-node>
    <div class="h-[48px] flex items-center">
      <svg-icon *ngIf="node.isExpanded" [iconName]="'new/up_1.svg'" class="mx-2" ></svg-icon>
      <svg-icon *ngIf="!node.isExpanded" [iconName]="'new/down_1.svg'" class="mx-2" ></svg-icon>
    </div>
  </ng-template>
  <ng-template #nzTreeTemplate let-node let-origin="origin">
    <span class="custom-node">
      <span *ngIf="!node.isLeaf">
        <svg-icon *ngIf="node.isExpanded" [iconName]="'new/document.svg'" class="mx-1" ></svg-icon>
        <svg-icon *ngIf="!node.isExpanded" [iconName]="'new/document.svg'" class="mx-1" ></svg-icon>
        <span class="folder-name truncate" [attr.title]='node.title'>{{ node.title }}</span>
      </span>
      <span *ngIf="node.isLeaf">
        <svg-icon [iconName]="'new/document.svg'" class="mx-1" ></svg-icon>
        <span class="file-name truncate" [attr.title]='node.title'>{{ node.title }}</span>
      </span>
    </span>
  </ng-template>
</div>


